// The shared shell behind SongTile and PlaylistTile: a square of artwork with
// a one-line title and subtitle beneath. Mirrors the common structure of
// SongTileView and PlaylistTileView, which are identical apart from what fills
// the square.

export interface TileFrameProps {
  /**
   * Fixed edge length for the tile, or null to fill the available width — the
   * same choice as `fixedWidth: CGFloat?` on the SwiftUI tile views. Scrollers
   * and the home grid pass a width; the playlist grid passes null so tiles
   * flex with their column.
   */
  width: number | null;
  title: string;
  subtitle: string | null;
  onClick: () => void;
  /** Fills the square artwork slot. */
  children: React.ReactNode;
}

export default function TileFrame(props: TileFrameProps) {
  const fixedWidth = props.width;
  const flexible = fixedWidth === null;

  return <button
    type="button"
    onClick={props.onClick}
    style={flexible ? undefined : { width: fixedWidth }}
    className={`flex flex-col gap-2 text-left transition-opacity duration-200 hover:opacity-75 ${flexible ? "w-full" : ""}`}
  >
    {/* aspectRatio(1) + RoundedRectangle(cornerRadius: 8) */}
    <div
      className={`w-full overflow-hidden rounded-lg bg-gray-200 ${flexible ? "aspect-square" : ""}`}
      style={flexible ? undefined : { height: fixedWidth }}
    >
      {props.children}
    </div>

    <div className="flex w-full flex-col">
      <span className="truncate text-[17px] font-semibold text-gray-900">
        {props.title}
      </span>
      {props.subtitle && (
        <span className="truncate text-[15px] text-gray-500">
          {props.subtitle}
        </span>
      )}
    </div>
  </button>
}
